import Constants from 'helpers/Constants'

const mobileOnly = () => `
  @media only screen and (max-width: ${Constants.mobileWidth}px)
`

const desktopOnly = () => `
  @media only screen and (min-width: ${Constants.mobileWidth + 1}px)
`

export default {
  desktopOnly,
  mobileOnly,
}



// WEBPACK FOOTER //
// ./src/helpers/Util.js